import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";

export default function Hero({ onOpenQuote }) {
  const heroBg =
    "https://static.prod-images.emergentagent.com/jobs/f60ae1e6-6bb5-4834-a099-1fb4ea0ab263/images/497153a52cb979f2668cd759ccd3a248c755918dd14df4320595fd9766eb07e2.png";

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center overflow-hidden pt-32 pb-24"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-70"
        style={{ backgroundImage: `url(${heroBg})` }}
      />
      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050507] via-[#050507]/60 to-[#050507]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_30%,rgba(229,36,49,0.25),transparent_60%),radial-gradient(ellipse_at_70%_70%,rgba(31,44,110,0.25),transparent_60%)]" />
      <div className="grain absolute inset-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass mb-8">
            <Sparkles size={14} className="text-[#E52431]" />
            <span className="text-xs tracking-wider uppercase text-white/70">
              Agence digitale premium
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-outfit text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] leading-[0.95] font-light tracking-tight"
          >
            Donnez à votre entreprise{" "}
            <span className="gradient-text font-medium">une image</span>{" "}
            <br className="hidden md:block" />
            à la hauteur de vos{" "}
            <span className="italic text-white/90">ambitions.</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 text-lg md:text-xl text-white/65 max-w-2xl leading-relaxed font-light"
          >
            Branding, visuels, stratégie digitale et création de sites web
            pensés pour <span className="text-white">attirer</span>,{" "}
            <span className="text-white">convaincre</span> et{" "}
            <span className="text-white">convertir</span>.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href="#accompagnement"
              data-testid="hero-cta-offres"
              className="inline-flex items-center justify-center gap-2 rounded-full gradient-bg text-white font-medium px-8 py-4 hover:shadow-[0_0_40px_rgba(229,36,49,0.45)] transition-all duration-300 btn-shine"
            >
              Voir les offres
              <ArrowRight size={18} />
            </a>
            <button
              data-testid="hero-cta-devis"
              onClick={onOpenQuote}
              className="inline-flex items-center justify-center gap-2 rounded-full glass text-white font-medium px-8 py-4 hover:bg-white/10 transition-all duration-300"
            >
              Demander un devis
            </button>
          </div>

          <div className="mt-20 flex flex-wrap gap-x-12 gap-y-4 text-xs uppercase tracking-[0.2em] text-white/45">
            <span>Engagement</span>
            <span className="text-white/15">•</span>
            <span>Innovation</span>
            <span className="text-white/15">•</span>
            <span>Croissance</span>
            <span className="text-white/15">•</span>
            <span>Collaboration</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
